let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4LE5S")).then(() => parcelRequire('9Mzd5'));